module.exports = __webpack_public_path__ + "static/logo_lockup-7ab2290607c784a122d1e2d52e6c547c.svg";